import { ColorTextWhite, ColorBlack, PillBadgeColorYellowText, PillBadgeColorYellowHoverBackground, PillBadgeColorYellowDefaultBackground, PillBadgeColorGreenText, PillBadgeColorGreenHoverBackground, PillBadgeColorGreenDefaultBackground, PillBadgeColorDarkGrayText, PillBadgeColorDarkGrayHoverBackground, PillBadgeColorDarkGrayDefaultBackground, PillBadgeColorPurpleText, PillBadgeColorPurpleHoverBackground, PillBadgeColorPurpleDefaultBackground, PillBadgeColorOrangeText, PillBadgeColorOrangeHoverBackground, PillBadgeColorOrangeDefaultBackground, PillBadgeColorRedText, PillBadgeColorRedHoverBackground, PillBadgeColorRedDefaultBackground, PillBadgeColorBlueText, PillBadgeColorBlueHoverBackground, PillBadgeColorBlueDefaultBackground } from "@nxt-costco-com/forge-design-tokens";
const COMPONENT_NAME = "PillBadge";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter`;
const INVALID_COMPONENT_TYPE = `${COMPONENT_NAME}-error: Invalid componentType prop, it should either 'div' or 'li'`;
const ELEMENT_TYPES = ["div", "li"];
var PillBadgeColors = /* @__PURE__ */ ((PillBadgeColors2) => {
  PillBadgeColors2["BLUE"] = "blue";
  PillBadgeColors2["RED"] = "red";
  PillBadgeColors2["ORANGE"] = "orange";
  PillBadgeColors2["PURPLE"] = "purple";
  PillBadgeColors2["DARKGRAY"] = "darkGray";
  PillBadgeColors2["GREEN"] = "green";
  PillBadgeColors2["YELLOW"] = "yellow";
  PillBadgeColors2["BLACK"] = "black";
  return PillBadgeColors2;
})(PillBadgeColors || {});
const PILL_BADGE_COLOR_MAP = {
  [
    "blue"
    /* BLUE */
  ]: {
    backgroundColor: PillBadgeColorBlueDefaultBackground,
    hoverBackgroundColor: PillBadgeColorBlueHoverBackground,
    textColor: PillBadgeColorBlueText
  },
  [
    "red"
    /* RED */
  ]: {
    backgroundColor: PillBadgeColorRedDefaultBackground,
    hoverBackgroundColor: PillBadgeColorRedHoverBackground,
    textColor: PillBadgeColorRedText
  },
  [
    "orange"
    /* ORANGE */
  ]: {
    backgroundColor: PillBadgeColorOrangeDefaultBackground,
    hoverBackgroundColor: PillBadgeColorOrangeHoverBackground,
    textColor: PillBadgeColorOrangeText
  },
  [
    "purple"
    /* PURPLE */
  ]: {
    backgroundColor: PillBadgeColorPurpleDefaultBackground,
    hoverBackgroundColor: PillBadgeColorPurpleHoverBackground,
    textColor: PillBadgeColorPurpleText
  },
  [
    "darkGray"
    /* DARKGRAY */
  ]: {
    backgroundColor: PillBadgeColorDarkGrayDefaultBackground,
    hoverBackgroundColor: PillBadgeColorDarkGrayHoverBackground,
    textColor: PillBadgeColorDarkGrayText
  },
  [
    "green"
    /* GREEN */
  ]: {
    backgroundColor: PillBadgeColorGreenDefaultBackground,
    hoverBackgroundColor: PillBadgeColorGreenHoverBackground,
    textColor: PillBadgeColorGreenText
  },
  [
    "yellow"
    /* YELLOW */
  ]: {
    backgroundColor: PillBadgeColorYellowDefaultBackground,
    hoverBackgroundColor: PillBadgeColorYellowHoverBackground,
    textColor: PillBadgeColorYellowText
  },
  [
    "black"
    /* BLACK */
  ]: {
    backgroundColor: ColorBlack,
    hoverBackgroundColor: ColorBlack,
    textColor: ColorTextWhite
  }
};
const FALLBACK_PILL_BADGE_COLOR = PILL_BADGE_COLOR_MAP[
  "blue"
  /* BLUE */
];
export {
  COMPONENT_NAME,
  ELEMENT_TYPES,
  FALLBACK_PILL_BADGE_COLOR,
  INVALID_COMPONENT_TYPE,
  INVALID_PROPS_ERROR,
  PILL_BADGE_COLOR_MAP,
  PillBadgeColors
};
